import React, { Component } from "react"
import { Form } from "react-bootstrap"
import DatePicker from "react-datepicker"
import CalculateDateStrings from "./OrderRequests/CalculateDateStrings"

interface ExpirationDateProps {
  expirationDate: Date | undefined
  disabled?: boolean
  timezone: string | undefined
  onChange(date: Date | [Date, Date] | null): void
}

interface ExpirationDateState {
  expirationDate: Date | undefined
}

export default class ExpirationDate extends Component<ExpirationDateProps, ExpirationDateState> {
  state: ExpirationDateState = { expirationDate: undefined }
  datePickerRef = React.createRef<DatePicker>()

  componentDidUpdate(prevProps: Readonly<ExpirationDateProps>) {
    if (this.props.expirationDate !== prevProps.expirationDate) {
      this.setState({ expirationDate: this.props.expirationDate })
    }
  }

  addHoursToCurrentDate = (hours: number) => {
    const newDate = new Date()
    newDate.setHours(newDate.getHours() + hours)
    return newDate
  }

  onChangeDate = (date: Date | [Date, Date] | null) => {
    this.setState({ expirationDate: date as Date || undefined })
    this.props.onChange(date)
  }

  render() {
    const { expirationDate } = this.state
    const displayExpirationDate = expirationDate ? CalculateDateStrings(expirationDate, this.props.timezone).gmtShortDate : ""

    return <>
      <DatePicker className="form-control"
        ref={this.datePickerRef}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        minDate={new Date()}
        maxDate={this.addHoursToCurrentDate(2160)}
        selected={this.state.expirationDate as Date}
        enableTabLoop={false}
        timeInputLabel="Time:"
        dateFormat="MM/dd/yyyy h:mm aa"
        showTimeInput
        disabled={!!this.props.disabled}
        onKeyDown={(e) => { if (this.datePickerRef && this.datePickerRef.current && e.key === 'Tab') { this.datePickerRef.current.setOpen(false) } }}
        onChange={this.onChangeDate} />
    </>
  }
}
